<!-- Hero Section -->
<section
  class="bg-[url('/assets/images/group.webp')] bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[30vh] flex flex-col justify-center items-center text-white px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="container flex flex-col justify-center items-center text-center">
    <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-3">
      Used Tesla For Sale
    </h1>
    <p class="text-white font-medium text-center text-lg lg:text-xl">
      Explore our selection of pre-owned Teslas, carefully inspected for quality
      and ready for the road.
    </p>
  </div>
</section>

<div class="py-[20px] bg-white px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div class="container pb-[1.6rem] pt-[1.6rem] mx-auto px-3 md:px-0">
    <div class="flex text-left flex-wrap ml-[-1.6rem]">
      <div
        class="w-full h-fit basis-[100%] lg:basis-[30%] xl:basis-[20%] pl-[1.6rem]"
      >
        <out-listings-filter
          (filterChange)="loadListings($event)"
        ></out-listings-filter>
      </div>

      <div
        class="basis-[100%] lg:basis-[70%] xl:basis-[80%] pl-[1.6rem] pt-[1.6rem] xl:pt-0 relative"
      >
        <div class="flex justify-end mb-3">
          <!-- <p class="text-[#7E7E7E] font-semibold">
            {{ totalListings | number }} results
          </p> -->
          <label for="sort">
            Sort:
            <select
              [(ngModel)]="sortSelected"
              (change)="onSortChange(sortSelected)"
              id="sort"
              class="bg-transparent cursor-pointer hover:outline-none disabled:opacity-100 tracking-[0.09px]"
            >
              <option *ngFor="let option of sortOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </label>
        </div>

        <div
          class="w-full grid md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-4 2xl:gap-x-7 xl:gap-y-10"
        >
          <div *ngFor="let listing of listings">
            <out-listing-card
              [listing]="listing"
              [showDescription]="false"
            ></out-listing-card>
          </div>
        </div>

        <div  *ngIf="!isLoading && !isSkeletonLoad && listings.length === 0">
          <div
            class="!bg-white shadow no_listings border rounded-lg text-center py-32 lg:py-42"
          >
            <img
          src="/assets/images/no-data.png"
          class="mx-auto size-28 2xl:size-42"
          alt="No data image"
        />
            <p class="text-gray-500 text-lg 2xl:text-xl font-medium">
              No listings available for your search criteria
            </p>
            <button
              (click)="clearFilters()"
              class="rounded-full bg-OUT-Blue hover:bg-OUT-Blue/90 font-semibold transition-colors duration-300 px-6 py-2 text-white mt-3 mb-1.5 ml-1.5 cursor-pointer text-[#e80013] text-sm"
            >
              Reset Filters
            </button>
          </div>
        </div>

        <div
          *ngIf="isSkeletonLoad"
          class="w-full grid md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-x-7 xl:gap-y-10"
        >
          <div *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
            <out-listing-skeleton></out-listing-skeleton>
          </div>
        </div>

        <div class="w-full flex justify-center items-center mt-10">
          <out-listings-paginator
            [skip]="skipListings"
            [totalResults]="totalListings"
            (pageChange)="loadListings($event)"
          ></out-listings-paginator>
        </div>

        <div
          class="backdrop-blur-sm"
          [ngClass]="[
            isLoading && !isSkeletonLoad
              ? 'fixed z-50 left-0 top-0 w-screen h-full bg-black/85 flex items-center justify-center'
              : 'hidden'
          ]"
        >
          <div role="status" class="relative flex justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="size-28"
              viewBox="0 0 24 24"
            >
              <path
                fill="#4d4d4d"
                d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z"
                opacity="0.5"
              />
              <path
                fill="#fff"
                d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"
              >
                <animateTransform
                  attributeName="transform"
                  dur="1s"
                  from="0 12 12"
                  repeatCount="indefinite"
                  to="360 12 12"
                  type="rotate"
                />
              </path>
            </svg>
            <img
              class="size-16 absolute top-1/2 left-1/2 p-2 rounded-full transform -translate-x-1/2 -translate-y-1/2 bg-white"
              src="assets/images/icon-out.svg"
              alt="Only Used Tesla Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
